// eslint-disable-next-line quasar/no-invalid-props
import { constants } from '../constants';
import { translateDescription, translateShortDescription, translateTitle } from '../language';

class CategoryModel {
  constructor(data) {
    this.id = data.id;
    this.codename = data.codename;
    this.title = data.title;
    this.titleEN = data.titleEN;
    this.shortDescription = data.shortDescription;
    this.shortDescriptionEN = data.shortDescriptionEN;
    this.description = data.description;
    this.descriptionEN = data.descriptionEN;
    this.images = data.images;
    this.tags = data.tags;
    this.children = data.children;
    this.products = data.products;
    this.openingHours = data.openingHours;
    this.active = data.active;
  }

  getTitle() {
    return translateTitle(this);
  }

  getShortDescription() {
    return translateShortDescription(this);
  }

  getDescription() {
    return translateDescription(this);
  }

  hasTag(codename) {
    if (this.tags) {
      return (this.tags.filter((t) => t.codename === codename).length > 0);
    }
    return false;
  }

  hasImages() {
    return this.images && this.images.length > 0;
  }

  setProtocol(url) {
    const protocol = process.env.RELEASE === 'production' ? 'https://' : 'http://';
    if (url && url.indexOf('//') === 0) {
      return url.replace('//', protocol);
    }

    return url;
  }

  getCoverImage() {
    const image = {
      src: null,
      srcset: '',
    };

    const sizes = [];

    if (this.images && this.images.length > 0) {
      const coverImage = this.images[0];
      image.src = this.setProtocol(coverImage.sizes.original);

      if (coverImage.sizes.xs) {
        image.srcset += `${this.setProtocol(coverImage.sizes.xs)} 600w,`;
        sizes.push('(max-width: 600px) 600px');
      }
      if (coverImage.sizes.sm) {
        image.srcset += `${this.setProtocol(coverImage.sizes.sm)} 1024w,`;
        sizes.push('(max-width: 1024px) 1024px');
      }
      if (coverImage.sizes.md) {
        image.srcset += `${this.setProtocol(coverImage.sizes.md)} 1440w,`;
        sizes.push('(max-width: 1440px) 1440px');
      }
      if (coverImage.sizes.lg) {
        image.srcset += `${this.setProtocol(coverImage.sizes.lg)} 1920w,`;
        sizes.push('1920px');
      }

      if (sizes.length > 0) {
        image.sizes = sizes.join(',');
      }
    }

    return image;
  }

  isOpen(deliveryMethodId) {
    // If category has no opening hours
    // bypass check to use the location opening hours
    // to determine whether category is open or not
    if (!this.openingHours) {
      return true;
    }

    let isOpen = true;
    const preferredDeliveryMethodId = (deliveryMethodId) || constants.DEFAULT_DELIVERY_METHOD;

    if (this.openingHours.length > 0) {
      const now = new Date();
      // api 1-7 mon - sun | javascript 0-6 sun-sat
      const today = now.getDay() === 0 ? 7 : now.getDay();
      const time = (now.getHours() * 60) + now.getMinutes();

      this.openingHours.forEach((days) => {
        days.forEach((day) => {
          if (day.day === today && day.deliveryMethodId === preferredDeliveryMethodId) {
            if (time < day.start || time > day.end) {
              isOpen = false;
            }
          }
        });
      });
    }

    return isOpen;
  }

  // This is used on american style. Should be phased out
  isCategoryOpen(category) {
    return (this.checkIfCategoryIsOpen(category, 1)
      || this.checkIfCategoryIsOpen(category, 2)
      || this.checkIfCategoryIsOpen(category, 3)
    );
  }

  // eslint-disable-next-line class-methods-use-this
  checkIfCategoryIsOpen(category, deliveryMethodId) {
    // If category has no opening hours
    // bypass check to use the location opening hours
    // to determine whether category is open or not
    if (!category.openingHours) {
      return true;
    }

    let isCategoryOpen = false;
    if (category.openingHours) {
      const now = new Date();
      // api 1-7 mon - sun | javascript 0-6 sun-sat
      const today = now.getDay() === 0 ? 7 : now.getDay();
      const time = (now.getHours() * 60) + now.getMinutes();

      category.openingHours.forEach((days) => {
        days.forEach((day) => {
          if (day.day === today && day.deliveryMethodId === deliveryMethodId) {
            // Check if category is open
            if (time > day.start && time < day.end) {
              isCategoryOpen = true;
            }
          }
        });
      });
    }

    return isCategoryOpen;
  }
}

export default CategoryModel;
